import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const legalContent = {
  privacy: {
    title: 'Privacy Policy',
    updated: 'August 25, 2026',
    sections: [
      ['Information we collect', 'NutriTrack stores the account information you provide, nutrition goals, food logs, saved recipes, grocery items, progress data, and settings needed to provide the service. When you choose photo analysis, the selected image is processed to return nutrition information.'],
      ['How we use information', 'We use this information only to operate, secure, support, and improve NutriTrack, including calculating goals, saving your entries, restoring your account, and answering requests to the AI Nutrition Coach. We do not sell your personal information.'],
      ['Service providers', 'NutriTrack uses Cloudflare to host and process app data and AI requests. Apple processes App Store subscriptions and payment authorization. These providers process information only as needed to provide their services under their own security and privacy obligations. NutriTrack does not receive your full payment card number.'],
      ['Data control', 'You can review and update your information in the app. You can permanently delete your NutriTrack account and associated nutrition data from Settings. Some limited records may be retained when required for security, fraud prevention, accounting, or legal compliance.'],
      ['Health information', 'NutriTrack is a general wellness and nutrition tracking tool. Do not enter information you do not want stored with your account. The app is not a medical service and does not provide diagnosis or treatment.'],
      ['Contact', 'Questions or privacy requests can be sent to info@marketnest.org.'],
    ],
  },
  terms: {
    title: 'Terms of Use',
    updated: 'August 25, 2026',
    sections: [
      ['Subscription terms', 'New iOS customers must choose a NutriTrack Pro auto-renewing subscription. The monthly plan renews every month and the yearly plan renews every year. Eligible new subscribers receive a 3-day introductory trial. Apple displays the exact local price and asks you to confirm the subscription and payment method before the trial begins.'],
      ['Renewal and cancellation', 'After the trial, Apple charges the selected plan unless it is canceled at least 24 hours before the trial or current billing period ends. Your subscription renews automatically until canceled. Manage or cancel it in your Apple Account subscription settings. Apple handles billing, payment authorization, and eligible refunds.'],
      ['Using NutriTrack', 'You are responsible for keeping your account secure and for the information you enter. Do not misuse the service, attempt unauthorized access, or use NutriTrack in a way that violates applicable law.'],
      ['Nutrition disclaimer', 'NutriTrack provides general wellness, nutrition tracking, and educational information. It is not medical advice, diagnosis, or treatment. Consult a qualified healthcare professional before making major dietary changes, especially if you have a medical condition.'],
      ['Apple terms', 'Use of the iOS app is also governed by Apple’s Standard Licensed Application End User License Agreement.'],
      ['Contact', 'For account or app support, email info@marketnest.org.'],
    ],
  },
};

const LegalPage = ({ type }) => {
  const content = legalContent[type] || legalContent.terms;

  return (
    <main className="min-h-screen bg-white px-5 py-8 text-gray-900 dark:bg-gray-950 dark:text-white">
      <div className="mx-auto max-w-3xl">
        <Link
          to="/upgrade"
          className="mb-8 inline-flex items-center gap-2 text-sm font-semibold text-indigo-700 hover:text-indigo-900 dark:text-indigo-300 dark:hover:text-white"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to subscription
        </Link>
        <h1 className="text-3xl font-bold">{content.title}</h1>
        <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">Last updated {content.updated}</p>
        <div className="mt-8 divide-y divide-gray-200 border-y border-gray-200 dark:divide-gray-800 dark:border-gray-800">
          {content.sections.map(([heading, body]) => (
            <section key={heading} className="py-6">
              <h2 className="text-lg font-bold">{heading}</h2>
              <p className="mt-2 leading-7 text-gray-700 dark:text-gray-300">{body}</p>
            </section>
          ))}
        </div>
      </div>
    </main>
  );
};

export default LegalPage;
